import { type ServiceMethod } from '@/application/interfaces/service';

import { type CrossService } from '../model';

export type Params = {
  itemIds: number[];
};

export type Response = {
  data: CrossServicesData[];
};

export type CrossServicesData = {
  productId: number;
  skuId: string | null;
  services: CrossService[];
};

export type SearchParams = {
  products: { id: number }[];
};

const getCrossServices: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { itemIds } = data;

    const { body: response } = await httpClient.get<
      Response,
      undefined,
      SearchParams
    >('/api/v3/crosses/services', {
      ...options,
      searchParams: {
        products: itemIds.map((id) => ({ id })),
      },
    });

    return response;
  };

export default getCrossServices;
